<template>
  <span>
    <el-button
      size="mini"
      :disabled="order.status !== 'P'"
      @click="visible = true"
    >
      Delete
    </el-button>
    <el-dialog class="text-left" title="Delete Order" :visible.sync="visible">
      <p>This order will be canceled and all reserved inventories released back to the system. The user will receive an email notifying about the cancellation.</p>
      <el-form :model="form" :rules="rules" ref="form" @submit.prevent.native="onSubmit">
        <el-form-item label="Reason" prop="reason">
          <el-input v-model="form.reason" type="textarea" rows="5" placeholder="Enter a reason"></el-input>
        </el-form-item>
        <el-button size="small" native-type="submit" type="danger" :loading="loading">
          Confirm Deletion
        </el-button>
        <el-button size="small" @click="visible = false">
          Cancel
        </el-button>
      </el-form>
    </el-dialog>
  </span>
</template>

<script>
export default {
  props: {
    order: Object,
  },

  data() {
    return {
      visible: false,
      loading: false,
      form: {
        reason: null,
      },
      rules: {
        'reason': [
          { required: true, message: 'Enter the reason.', trigger: 'blur' },
        ],
      },
    }
  },

  methods: {
    async onSubmit() {
      this.$refs['form'].validate(async valid => {
        if (!valid) {
          return false
        }

        this.loading = true

        try {
          var { data } = await this.$http.delete(`/orders/${ this.order.id }`, {
            data: this.form
          })
        } catch(err) {
          this.$message.error(err.response.data.message)
          return false
        } finally {
          this.loading = false
        }

        this.$emit('success')
        this.$message.success(data.message)
        this.visible = false
      })
    },
  },
}
</script>
